import type { ChordId } from '../types';
import { CELESTIAL_CHORDS } from '../audio/celestialPadEngine';

interface Props {
  active?: boolean;
  chordId?: ChordId | null;
  className?: string;
}

const DEFAULT_NODES = [
  { bg: '#b39ddb', glow: 'none', opacity: 1 },
  { bg: '#90caf9', glow: 'none', opacity: 1 },
  { bg: '#a5d6a7', glow: 'none', opacity: 1 },
];

const ACTIVE_DEFAULT_NODES = [
  { bg: '#7e57c2', glow: '0 0 6px rgba(126,87,198,0.55)', opacity: 1 },
  { bg: '#42a5f5', glow: '0 0 6px rgba(66,165,245,0.5)', opacity: 1 },
  { bg: '#66bb6a', glow: '0 0 6px rgba(102,187,106,0.5)', opacity: 1 },
];

function nodesForChord(chordId: ChordId, active: boolean) {
  const chord = CELESTIAL_CHORDS.find((c) => c.id === chordId);
  if (!chord) return active ? ACTIVE_DEFAULT_NODES : DEFAULT_NODES;

  const base = chord.color;
  return [
    { bg: base, glow: active ? `0 0 7px ${base}99` : 'none', opacity: 1 },
    { bg: base, glow: active ? `0 0 5px ${base}77` : 'none', opacity: 0.82 },
    { bg: base, glow: active ? `0 0 5px ${base}77` : 'none', opacity: 0.64 },
  ];
}

/** Tres notas apiladas verticalmente — mismo gesto visual que acordes en Bordona. */
export function ChordStackIcon({ active = false, chordId = null, className = '' }: Props) {
  const nodes = chordId
    ? nodesForChord(chordId, active)
    : active
      ? ACTIVE_DEFAULT_NODES
      : DEFAULT_NODES;

  return (
    <span
      className={`chord-stack-icon ${active ? 'chord-stack-icon--active' : ''} ${className}`.trim()}
      aria-hidden="true"
    >
      {nodes.map((n, i) => (
        <span
          key={i}
          className="chord-stack-icon__note"
          style={{
            background: n.bg,
            boxShadow: n.glow,
            opacity: n.opacity,
          }}
        />
      ))}
    </span>
  );
}
